export default __webpack_public_path__ + "static/media/p2.39b4c387.svg";